import { HoverHintContent } from "@/components/ui/title-help";
import { cn } from "@/lib/utils";

const hubMockupHint =
  "Hub mock-up policy is active (workflow.app_settings hub.mockup).";

const pageBadgeClass =
  "inline-flex items-center rounded-full border border-amber-300/70 bg-amber-100/90 px-2 py-0.5 text-[11px] font-semibold leading-none text-amber-900/80";

const navBadgeClass =
  "inline-flex shrink-0 items-center rounded-full border border-amber-300/70 bg-amber-100/90 px-1.5 py-0 text-[10px] font-semibold leading-none text-amber-900/80";

export type HubMockupBadgeVariant = "page" | "nav";

type HubMockupBadgeProps = {
  variant?: HubMockupBadgeVariant;
  className?: string;
};

/** Muted pill label when hub mock-up policy is active (`workflow.app_settings` key `hub.mockup`). */
export function HubMockupBadge({ variant = "page", className }: HubMockupBadgeProps) {
  return (
    <HoverHintContent hoverHint={hubMockupHint} className={cn(variant === "nav" ? navBadgeClass : pageBadgeClass, className)}>
      Mock-up
    </HoverHintContent>
  );
}
